import httpClient from "../utils/httpClient";


//export const UserProfileData = async (params) => {
//    const response = await httpClient.post("/user/get-profile", params);
//    return response.data;
//};

export const UserProfileData = async () => {
    const response = await httpClient.post("/user/get-profile", {});
    return response.data;
};


export const updateProfile = async (userData) => {
    const response = await httpClient.post('/User/update-profile', userData);
    return response.data;
};


